import { useWeb3React } from '@web3-react/core'
import Loading from 'components/Loading'
import { ActivationStatus, useActivationState } from 'connection/activate'
import { Connection } from 'connection/types'
import {
  WalletOption,
  WalletOptionIcon,
  WalletOptionImg,
  WalletOptionName,
} from './styles'
import { updateModal } from '../../store/app/actions/modalActions'
import { useAppDispatch } from '../../store'
import { useIsDepositPage } from '../../store/deposit/hook'
import { updateChainType } from '../../store/connect/reducer'
import { ChainType } from '../../constants/chains'

export default function EvmWalletOption({
  connection,
  isRecent,
}: {
  connection: Connection
  isRecent: boolean
}) {
  const dispatch = useAppDispatch()
  const { activationState, tryActivation } = useActivationState()
  const { chainId } = useWeb3React()
  const isDepositPage = useIsDepositPage()

  const { name, icon } = connection.getProviderInfo()

  const isSomeOptionPending =
    activationState.status === ActivationStatus.PENDING
  const isCurrentOptionPending =
    isSomeOptionPending && activationState.connection === connection

  const rightSideDetail = isCurrentOptionPending ? (
    <Loading size={10} />
  ) : isRecent ? (
    <div />
  ) : null

  const activate = () =>
    tryActivation(
      connection,
      () => {
        dispatch(updateChainType({ chainType: ChainType.Evm }))
        if (!isDepositPage) {
          dispatch(updateModal({ modal: 'verify', open: true }))
        }
      },
      chainId,
    )

  return (
    <WalletOption onClick={activate}>
      <WalletOptionIcon>
        <WalletOptionImg src={icon} alt={name} />
      </WalletOptionIcon>
      <WalletOptionName>{name}</WalletOptionName>
      {rightSideDetail}
    </WalletOption>
  )
}
